import React, {useState, useContext} from 'react';
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import {GlobalStateContext} from "../global/context/GlobalStateContext";
import {DELETE_DEVICE_EXCLUDED_ASSET_TYPES} from "../util/Constants";

const DeleteSingleDeviceModal = (props) => {

    const {formatMessage} = props.intl;
    const {open, setOpen, selected, setSelected, assetType} = props;
    const [valueMacAddress, setValueMacAddress] = useState("")
    const {showWarning} = useContext(GlobalStateContext);
    const {showCustomAlert} = useContext(GlobalStateContext);

    const onCloseModal = () => {
        setOpen(false)
        setSelected("");
        resetInputState();
    }

    const onClickConfirm = (mac) => {
        showWarning(formatMessage({id: "device.editWarning"}), () => {
            deleteData(mac);
            setOpen(false);
            resetInputState();
            getData();
        });
    };

    function resetInputState() {
        setValueMacAddress("");
    }

    const prefill = () => {
        if (!selected)
            return;
        setValueMacAddress(selected);
    }

    const deleteData = (mac) => {
        props.dispatch({type: 'DELETE_DEVICE_DATA', data: {dispatcher: props.dispatch, mac: mac,
                assetType: assetType, showCustomAlert: showCustomAlert}})
    }

    const getData = () => {
        if (!DELETE_DEVICE_EXCLUDED_ASSET_TYPES.includes(assetType)) {
            props.dispatch({type: 'LOAD_VIEW', data: {dispatcher: props.dispatch, assetType: assetType}});
        }
    }

    return (
        <Modal
            title={formatMessage({id: "device.delete_device_button_modal"})}
            open={open}
            onOpen={prefill}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium">
            <Column spacing={"medium"} spacingInset={"medium"}>
                <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                    { selected ?
                        <FormattedMessage id="modal.confirmmacdelete"
                                          defaultMessage="Please confirm that you wish to delete the following device:"/>
                        : <FormattedMessage id="modal.macdelete"
                                            defaultMessage="Please enter the MAC Address of the device you would like to remove."/>
                    }
                </Text>
                { selected ?
                    <Text type={"h300"}> {valueMacAddress} </Text>
                    : <Select
                        value={valueMacAddress}
                        onChange={setValueMacAddress}
                        placeholder={<FormattedMessage id="modal.selectmacdelete"
                                           defaultMessage="Select MAC Address to be deleted."/>}
                        width={300}>
                        {props.macAddressArray.map((device) => (
                            <SelectOption key={device} value={device}
                                          label={device}/>
                        ))}
                        {!props.macAddressArray.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                <Text alignment="center">
                                    <FormattedMessage id="modal.no_device_available"
                                              defaultMessage="No devices available"/>
                                     </Text>
                            </Column>) : null}
                    </Select>
                }
            </Column>
            <ModalFooter>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button type="secondary" size="medium" onClick={onCloseModal}>
                        <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                    </Button>
                    <Button type="primary" size="medium"
                            onClick={() => onClickConfirm(valueMacAddress)}>
                        <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default injectIntl(DeleteSingleDeviceModal);



// WEBPACK FOOTER //
// ./src/components/commonui/DeleteSingleDeviceModal.js